export default {"src":"/oferta/_next/static/media/celiacs.6e501c56.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};